import { InjectionToken } from '@angular/core';

export const TRANSLATIONS = new InjectionToken<any>('TRANSLATIONS');
export const DEFAULT_LANGUAGE = new InjectionToken<any>('DEFAULT_LANGUAGE');
export const LANGUAGES = new InjectionToken<any>('LANGUAGES');
